import React from 'react';
import { BaasicInput, BaasicErrorModal, BaasicConfirmModal, BaasicDropdown } from 'core/components';
import _ from 'lodash';
import { renderIf, translate } from 'core/utils';
import { defaultTemplate } from 'core/hoc';

function DivTableRow({ data }) {
	let rowId = 'table__settings__item' + data.key;
	return (
		<div id={rowId} className="table__settings__item" onClick={() => data.viewStore.onColumnSelect(data.key)}>
			{data.label}
		</div>
	);
}

const BaasicTableSettingsTemplate = ({ modalParams, modalParams: { data } }) => {
	return (
		<React.Fragment>
			<div className="ReactModal__header">
				<div className="flex--secondary">
					<h3 className="spc--bottom--sml">{translate('BAASICTABLESETTINGS.TABLESETTINGS')}</h3>
					{data.templates && data.templates.length > 0 && (
						<BaasicDropdown dropdownStore={data.templateDropdownStore} placeholder={translate('BAASICTABLESETTINGS.SELECT')} className="w--200--px spc--bottom--sml" />
					)}
				</div>
			</div>

			<div className="ReactModal__body">
				<div className="table__settings spc--bottom--sml" id="tableSettings">
					<div className="table__settings__box">
						<div className="table__settings__scroll">
							<div className="table__settings__item first">{translate('BAASICTABLESETTINGS.AVAILABLECOLUMNS')}</div>
							<div>
								{data.availableColumns.map(column => {
									let rowData = {
										key: column.key,
										label: translate(column.title),
										viewStore: data,
									};
									return <DivTableRow key={column.key} data={rowData} />;
								})}
							</div>
						</div>
					</div>
					<div className="table__settings__box narrow">
						<button
							className="btn btn--icon btn--primary spc--bottom--sml"
							type="button"
							onClick={() => data.onTransferColumn('add')}
							disabled={data.addButton}
						>
							<i className="fa fa-arrow-right"></i>
						</button>
						<button
							className="btn btn--icon btn--primary"
							type="button"
							onClick={() => data.onTransferColumn('remove')}
							disabled={data.removeButton}
						>
							<i className="fa fa-arrow-left"></i>
						</button>
					</div>
					<div className="table__settings__box">
						<div className="table__settings__scroll">
							<div className="table__settings__item first">{translate('BAASICTABLESETTINGS.SELECTEDCOLUMNS')}</div>
							<div>
								{data.selectedColumns
									.filter(column => {
										if (column.locked) {
											return false;
										} else {
											return true;
										}
									})
									.map(column => {
										let rowData = {
											key: column.key,
											label: translate(column.title),
											viewStore: data,
										};
										return <DivTableRow key={column.key} data={rowData} />;
									})}
							</div>
						</div>
					</div>
					<div className="table__settings__box narrow last">
						<button
							className="btn btn--icon btn--primary spc--bottom--sml upbtn"
							type="button"
							onClick={() => data.moveColumn('up')}
							disabled={data.moveUpButton}
						>
							<i className="fa fa-angle-up"></i>
						</button>
						<button
							className="btn btn--icon btn--primary downbtn"
							type="button"
							onClick={() => data.moveColumn('down')}
							disabled={data.moveDownButton}
						>
							<i className="fa fa-angle-down"></i>
						</button>
					</div>
				</div>
			</div>

			<form className="ReactModal__footer" onSubmit={data.form.onSubmit}>
				{((data.templateAlreadyExists && !data.newTemplate && !data.templateAlreadyExistsColumns) ||
					(data.newTemplateConfirmed &&
						!data.isInput &&
						!data.templateAlreadyExistsColumns &&
						!data.saveButton &&
						!data.templateAlreadyExists) ||
					(data.newTemplateConfirmed && data.templateAlreadyExistsColumns && !data.newTemplate) ||
					data.newTemplateConfirmed) && (
					<div className="ReactModal__footer--template">
						{data.newTemplateConfirmed && (
							<div className="inputgroup w--400--px">
								<div className="inputgroup--main">
									<BaasicInput
										onKeyUp={data.validateTemplateName}
										field={data.form.$('templateName')}
										showCheckmark={false}
										autoFocus={data.isInput}
										onBlur={data.onBlur}
										validation={false}
										className="spc--right--sml"
									/>
								</div>
								<div className="inputgroup--aside">
									<div className="inputgroup">
										<label className="form__label">&nbsp;</label>
										<button type="button" className="btn btn--med btn--outline" onClick={data.cancelNewTemplate}>
											{translate('CANCEL')}
										</button>
									</div>
								</div>
							</div>
						)}
						{((data.templateAlreadyExists && !data.newTemplate && !data.templateAlreadyExistsColumns) ||
							(data.newTemplateConfirmed &&
								data.isTemplateNameEmpty &&
								!data.isInput &&
								!data.templateAlreadyExistsColumns &&
								!data.templateAlreadyExists) ||
							(data.newTemplateConfirmed && data.templateAlreadyExistsColumns && !data.newTemplate)) && (
							<ul className="message message--error spc--bottom--sml">
								{data.templateAlreadyExists && !data.newTemplate && !data.templateAlreadyExistsColumns && (
									<li>
										<p className="type--tny type--color--error">{translate('EXISTINGTEMPLATENAME')}</p>
									</li>
								)}
								{data.newTemplateConfirmed &&
									data.isTemplateNameEmpty &&
									!data.isInput &&
									!data.templateAlreadyExistsColumns &&
									!data.templateAlreadyExists && (
										<li>
											<p className="type--tny type--color--error">{translate('MESSAGES.REQUIRED.TEMPLATE.NAME')}</p>
										</li>
									)}
								{data.newTemplateConfirmed && data.templateAlreadyExistsColumns && !data.newTemplate && (
									<li>
										<p className="type--tny type--color--error">
											{translate('BAASICTABLESETTINGS.EXISTINGTEMPLATECOLUMNLAYOUT', {
												name: data.templateAlreadyExistsColumns,
											})}
										</p>
									</li>
								)}
							</ul>
						)}
					</div>
				)}

				<div className="flex--secondary">
					<div>
						<button
							className="btn btn--med btn--secondary spc--right--sml spc--bottom--sml"
							onClick={modalParams.close}
						>
							{translate('CLOSE')}
						</button>
						{renderIf(data.templates && data.templates.length > 0 && data.templateDropdownStore.value)(
							<button
								type="button"
								className="btn btn--med spc--right--sml spc--bottom--sml"
								onClick={data.openConfirmModal}
								disabled={
									data.baasicTableSettingsKey === 'FulfillmentOrdersTableSettings' &&
									data.templateDropdownStore.value.label === 'default template'
								}
							>
								{translate('BAASICTABLESETTINGS.DELETE')}
							</button>
						)}
					</div>

					<div>
						{renderIf(data.newTemplate)(
							<button
								type="button"
								className="btn btn--med btn--primary spc--right--tny spc--right--sml spc--bottom--sml"
								onClick={data.onNewTemplate}
							>
								{translate('BAASICTABLESETTINGS.SAVEASNEWTEMPLATE')}
							</button>
						)}
						<button
							type="submit"
							className="btn btn--med btn--primary spc--bottom--sml"
							onClick={data.onSaveAndApply}
							disabled={!data.saveButton}
						>
							{translate('BAASICTABLESETTINGS.SAVEANDAPPLY')}
						</button>
					</div>
				</div>
			</form>
			<BaasicErrorModal modalParams={data.errorModal} />
			<BaasicConfirmModal modalParams={data.confirmModal} />
		</React.Fragment>
	);
};

export default defaultTemplate(BaasicTableSettingsTemplate);
